export default __webpack_public_path__ + "static/media/loginImage.93e66add.svg";